<template>
    <div id="findcustomer">
        <b-modal :active.sync="showAddCustomerModal" aria-modal :width="800" scroll="keep">
            <header class="modal-card-head">
                <p class="modal-card-title">Klant toevoegen</p>
            </header>
            <section class="modal-card-body">
                <!-- <div class="row" v-if="user && user.role === 'pit'">
                    <div class="column paddingtop0">
                        <b-field label="Organisatie">
                            <b-select v-model="dataBelongsTo" class="databelongsto" expanded>
                                <option value="all">Alle (organisaties)</option>
                                <option
                                    v-for="(organisation, id) in organisations"
                                    :value="id"
                                    :key="id"
                                >(ID: {{ organisation.id }}) {{ organisation.name }}
                                </option>
                            </b-select>
                        </b-field>
                    </div>
                </div> -->

                <div class="row">
                    <div class="column">
                        <b-field grouped>
                            <b-input expanded v-model="searchTerm" placeholder="Zoeken naar klant op voornaam, achternaam, email of plaats"></b-input>
                            <p class="control">
                                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                                </b-tooltip>
                            </p>
                            <!-- <p class="control" v-if="canAddCustomer">
                                <b-button type="is-info" @click="addCustomer">Klant toevoegen</b-button>
                            </p> -->
                        </b-field>
                    </div>
                </div>

                <b-table
                    :data="isEmpty ? [] : results"
                    :narrowed="true"
                    :hoverable="true"
                    :loading="searching"
                    :mobile-cards="true"

                    backend-pagination
                    :total="total"
                    :per-page="perPage"
                    @page-change="onPageChange"
                    backend-sorting
                    :default-sort-direction="sortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"

                    :paginated="paginated"
                    :sort-icon="'chevron-up'"
                >
                    <template>
                        <b-table-column v-slot="props" field="lastname" label="Naam" width="200" sortable>
                            <span v-if="hideSensitiveData">********</span>
                            <span v-else>
                                {{ props.row.firstname }}&nbsp;{{ props.row.lastname }}
                                <span v-if="!_.isNull(props.row.companyname) && props.row.type == 'business'">
                                    <strong>({{ props.row.companyname }})</strong>
                                </span>
                            </span>
                        </b-table-column v-slot="props">

                        <b-table-column v-slot="props" field="email" label="E-mail" sortable>
                            <span style="width: 150px;display: inline-block;white-space: nowrap;overflow: hidden !important;text-overflow: ellipsis;">
                                {{ hideSensitiveData ? '********' : props.row.email }}
                            </span>
                        </b-table-column v-slot="props">

                        <b-table-column v-slot="props" field="city" label="Plaats" sortable>
                            {{ hideSensitiveData ? '********' : props.row.city }}
                        </b-table-column v-slot="props">

                        <b-table-column v-slot="props" field="updated_at" label="Laatst gewijzigd" width="180" sortable>
                            {{ props.row.updated_at|humanDate }}
                        </b-table-column v-slot="props">

                        <b-table-column v-slot="props" width="55" right>
                            <b-button type="is-success" @click="linkCustomer(props.row)" :loading="results.selectId == props.row.id">
                                <font-awesome-icon :icon="['fas', 'check']" />
                            </b-button>
                        </b-table-column v-slot="props">
                    </template>

                    <template #empty>
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <span v-if="!searching">
                                    <span v-if="searchTerm.length">
                                        <p>Geen resultaten met zoekterm "{{ searchTerm }}"</p>
                                    </span>
                                    <span v-else>
                                        <p>Je hebt nog geen klanten.</p>
                                    </span>
                                </span>
                            </div>
                        </section>
                    </template>
                </b-table>
            </section>
            <!-- <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Close</button>
                <button class="button is-primary">Login</button>
            </footer> -->
        </b-modal>

        <div class="results" v-if="!onlyModal">
            <div v-if="buttonOnly">
                <div v-if="canAddCustomer">
                    <b-button type="is-info" @click="addCustomer">Bestaande klant zoeken</b-button>
                </div>
            </div>

            <template v-else>
                <div class="column small-5" v-if="canAddCustomer" style="padding-right:0;">
                    <b-button type="is-info" class="float-right" @click="addCustomer">Bestaande klant zoeken</b-button>
                </div>

                <CRUDCustomer
                    id="nieuw"
                    type="edit"
                    embedded_from="ContractRecord"
                    :canRemoveCustomer="false"
                    :organisation="dataBelongsTo"
                    :ibanRequired="ibanRequired"
                    @closeModal="showAddCustomerModal = false"
                    @fullPageLoader="fullPageLoader"
                    @linkCustomer="linkCustomer"
                />
            </template>
        </div>
    </div>
</template>


<script>
import Vue from 'vue'
import CRUDCustomer from './CRUDCustomer'
import filtersMixin from '@/mixins/filterMixins'

export default {
    mixins: [filtersMixin],

    props: {
        organisation: {
            type: [Number, String],
            required: false,
            default: null
        },
        showAllCustomers: {
            type: Boolean,
            required: true
        },
        canAddCustomer: {
            type: Boolean,
            required: false,
            default: true
        },
        buttonOnly: {
            type: Boolean,
            required: false,
            default: false
        },
        ibanRequired: {
            type: Boolean,
            required: false,
            default: false
        },
        onlyModal: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    components: {
        CRUDCustomer
    },

    data () {
        return {
            showAddCustomerModal: false,

            searchTerm: '',
            searching: false,
            results: [],
            isEmpty: true,
            total: 0,
            sortField: 'updated_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 15,
            dataBelongsTo: this.user?.organisation || null,
            searchParams: this.$store.state.searchQueries?.[this.$route.name] ?? null
        }
    },

    computed: {
        paginated(){
            return this.results.length < this.total
        },

        user() {
            return this.$store.state.user || null
        },

        organisations() {
            return this.$store.state.organisations || null
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        }
    },

    created (){
        if(this.showAllCustomers){
            this.getSearchParams().then(() => {
                this.searchCustomer()
            })
        }
    },

    methods: {
        // TODO: Make me a mixin, im used alot!
        getSearchParams(){
            return new Promise((resolve) => {
                if(!_.isNull(this.searchParams)){
                    let searchParams = this.searchParams.split('&')
                    searchParams = searchParams[1].split('.')

                    this.sortField = searchParams[0].replace('sort_by=', '')
                    this.sortOrder = searchParams[1]

                    resolve()
                } else {
                    resolve()
                }
            })
        },

        searchCustomer: _.debounce(function() {
            let params
            this.searching = true

            console.log('[🚀] Start searching customer with SearchTerm: '+this.searchTerm)
            let paramArray = []

            // If we pass an organisation, we only want to show customers from that organisation
            if (this.organisation) {
                paramArray.push(`organisation=${this.organisation}`)
            } else if (this.user.role == 'pit') {
                paramArray.push(`organisation=${this.user.organisation}`)
            }

            // TODO: Make me a (variable) mixin, im used alot!
            if(!_.isNull(this.searchParams)){
                // Only once if searchparams are stored in Vuex.state.searchParams
                paramArray.push(this.searchParams)
                this.$store.dispatch('setSearchQuery', {type: 'CustomersOverview', query: null}) // Unset after use
            } else {
                paramArray.push(
                    `paginate=${this.perPage}`,
                    `sort_by=${this.sortField}.${this.sortOrder}`,
                    `page=${this.page}`
                )
            }

            params = paramArray.join('&')

            axios({
                method: 'get',
                url: `/api/customers?${params}&searchterm=${this.searchTerm}`,
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                response.selectId = null

                this.results = response.data.data
                this.total = response.data.total
                this.page = response.data.current_page

                this.isEmpty = response.data.total == 0

                Vue.set(this, 'searching', false)
            }).catch((error) => {
                console.error('[❌] Error while fetching customers:', error)
                Vue.set(this, 'searching', false)
            })
        }, 300),

        addCustomer(){
            this.showAddCustomerModal = true
        },

        linkCustomer(customer){
            this.showAddCustomerModal = false
            this.$emit('linkCustomer', customer)
            Vue.set(this.results, 'selectId', customer.id)

            setTimeout(() => {
                Vue.delete(this.results, 'selectId')
            }, 1000)
        },

        onPageChange(page) {
            this.page = page
            this.searchCustomer()
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.searchCustomer()
        },

        fullPageLoader(value){
            this.loading = value
        },
    },
    watch: {
        searchTerm(){
            this.searchCustomer()

            Vue.set(this, 'searching', true)
            this.results.data = []
        },
        
        showAddCustomerModal(newVal) {
            // When modal opens, trigger search
            if (newVal === true) {
                this.searchCustomer()
            }
        }
    }
}
</script>